/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BinaryFileType } from '../../models/binary-file-type';
import { KeyType } from '../../models/key-type';
import { Token64LengthType } from '../../models/token-64-length-type';

export interface GetExternalDeliveryNoteCompletePdf$Params {

/**
 * The delivery note key
 */
  deliveryNoteKey: KeyType;
  token: Token64LengthType;
}

export function getExternalDeliveryNoteCompletePdf(http: HttpClient, rootUrl: string, params: GetExternalDeliveryNoteCompletePdf$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
  const rb = new RequestBuilder(rootUrl, getExternalDeliveryNoteCompletePdf.PATH, 'get');
  if (params) {
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/pdf', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BinaryFileType>;
    })
  );
}

getExternalDeliveryNoteCompletePdf.PATH = '/external/gate/delivery-notes/{deliveryNoteKey}/complete-pdf';
